import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import setLightness from 'polished/lib/color/setLightness'
import _distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import { AlertTriangle, Info } from 'react-feather'

import { isActive, isCurrent } from '../utils/alerts'
import { color, mixin } from '../globalStyles'
import Content from './Content'
import ShowMoreButton from './ShowMoreButton'

const CardWrap = styled.div`
  ${mixin.card};
  background: ${({ alertColor = color.primary }) =>
    setLightness(0.95, alertColor)};
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: flex-start;
  text-align: center;
`
const CardHeading = styled.h6`
  background: ${props => props.alertColor};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  font-size: 1.1rem;
  padding: 0.25rem;

  svg {
    margin-right: 0.3em;
    height: 1.5em;
  }
`
const CardContent = styled.div`
  padding: 1.5rem;

  a {
    color: inherit;
  }

  p:last-child {
    margin-bottom: 0;
  }
`
const Title = styled.h4`
  margin: 0;
`
const Message = styled(Content)`
  margin-top: 1rem;
`

const getAlertColour = type => {
  let alertColor = color.darkGrey
  if (type === 'success') alertColor = color.primary
  if (type === 'error') alertColor = color.danger
  if (type === 'warning') alertColor = color.warning
  return alertColor
}
const getAlertHeading = type => {
  let heading = 'Info'
  if (type === 'error') heading = 'Notice'
  if (type === 'warning') heading = 'Notice'
  return heading
}

const getAlertIcon = type => {
  let Icon = Info
  if (type === 'error' || type === 'warning') Icon = AlertTriangle
  return Icon
}

class AlertCard extends React.Component {
  static defaultProps = {
    title: null,
    message: null,
    type: 'info'
  }

  state = {
    open: false
  }

  handleOpen = e => {
    e.preventDefault()
    this.setState(prevState => ({
      open: !prevState.open
    }))
  }

  render () {
    const { title, type, message, updatedAt } = this.props
    const filtered = [this.props].filter(isActive).filter(isCurrent)
    if (!filtered.length) return null
    if (!message) return null
    const alertColor = getAlertColour(type)
    const Icon = getAlertIcon(type)
    const heading = getAlertHeading(type)
    return (
      <CardWrap alertColor={alertColor}>
        <CardHeading alertColor={alertColor}>
          <Icon /> {heading}
        </CardHeading>
        <CardContent>
          {title && <Title>{title}</Title>}
          {this.state.open && message && <Message source={message} />}
          {this.state.open &&
            updatedAt && (
              <sub>
                Updated {_distanceInWordsToNow(updatedAt, { addSuffix: true })}
              </sub>
            )}
          {message && (
            <ShowMoreButton
              open={this.state.open}
              handleOpen={this.handleOpen}
              border={false}
            />
          )}
        </CardContent>
      </CardWrap>
    )
  }
}

AlertCard.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  message: PropTypes.string.isRequired,
  timeRange: PropTypes.array
}

export default AlertCard



// WEBPACK FOOTER //
// ./src/components/AlertCard.js